class BlockchainMonitor {
  constructor() {
    this.validators = [
    'https://chainfree.info:5010/validator/1',
    'https://chainfree.info:5010/validator/2', 
    'https://chainfree.info:5010/validator/3',
    'https://chainfree.info:5010/validator/4'
];
    this.latestBlock = 0;
    this.validatorHealth = {};
  }

 async checkValidatorHealth() {
  console.log('Starting validator health check...');
  const healthStatus = {};
  
  for (const endpoint of this.validators) {
    console.log('Checking validator:', endpoint);
    try {
      // Add timeout using AbortController
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 5000); // 5 second timeout
      
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          jsonrpc: '2.0',
          method: 'eth_blockNumber',
          id: 1
        }),
        signal: controller.signal
      });
      
      clearTimeout(timeoutId);
      console.log('Response status for', endpoint, ':', response.status);
      
      if (response.ok) {
        const data = await response.json();
        console.log('Response data for', endpoint, ':', data);
        
        const blockNumber = parseInt(data.result, 16);
        console.log('Block number:', blockNumber);
        
        healthStatus[endpoint] = {
          status: 'healthy',
          blockNumber: blockNumber,
          lastChecked: Date.now()
        };
      } else {
        healthStatus[endpoint] = {
          status: 'unhealthy',
          error: `HTTP ${response.status}`,
          lastChecked: Date.now()
        };
      }
    } catch (error) {
      console.log('Error checking', endpoint, ':', error.message);
      healthStatus[endpoint] = {
        status: 'offline',
        error: error.message,
        lastChecked: Date.now()
      };
    }
  }
  
  console.log('Final health status:', healthStatus);
  this.validatorHealth = healthStatus;
  return healthStatus;
}
  async getLatestBlock() {
    try {
      // Try first available validator
      const response = await fetch(this.validators[0], {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          jsonrpc: '2.0',
          method: 'eth_blockNumber',
          id: 1
        })
      });
      
      const data = await response.json();
      this.latestBlock = parseInt(data.result, 16);
      return this.latestBlock;
    } catch (error) {
      console.log('Failed to get latest block:', error.message);
      return this.latestBlock;
    }
  }

  getHealthSummary() {
    const healthyCount = Object.values(this.validatorHealth)
      .filter(v => v.status === 'healthy').length;
    
    return {
      totalValidators: this.validators.length,
      healthyValidators: healthyCount,
      networkHealth: healthyCount >= 3 ? 'Good' : healthyCount >= 2 ? 'Fair' : 'Poor',
      latestBlock: this.latestBlock
    };
  }
}

export default new BlockchainMonitor();